import { StaffMember } from './staffMember';

export enum PTOType {
  PERSONAL_PAUSE = 'PERSONAL_PAUSE',
  HEALTH_PAUSE = 'HEALTH_PAUSE',
  GRIEF_PAUSE = 'GRIEF_PAUSE',
  PRIMARY_CAREGIVER = 'PRIMARY_CAREGIVER',
  SECONDARY_CAREGIVER = 'SECONDARY_CAREGIVER',
  HEALTH_LEAVE = 'HEALTH_LEAVE',
}

export type PTOHoursEntry = {
  id: string;
  date: Date;
  hours: number;
};

export enum PTOStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  DENIED = 'DENIED',
}

export type PTORequest = {
  answeredBy: Pick<
    StaffMember,
    'createdAt' | 'hiringDate' | 'id' | 'lastBankOfHoursResetDate' | 'updatedAt' | 'person'
  >;
  answeredById: string;
  decisionComment: string | null;
  decisionDate: Date | null;
  entries: PTOHoursEntry[];
  firstDay: Date;
  id: string;
  ptoType: PTOType;
  requestComment?: string;
  requestDate: Date;
  staffMemberId: string;
  status: PTOStatus;
  updatedAt: Date;
};

export const PTOStatusLabel: { [status in PTOStatus]: string } = {
  [PTOStatus.APPROVED]: 'Approved',
  [PTOStatus.DENIED]: 'Denied',
  [PTOStatus.PENDING]: 'Pending',
};

export type PTOPolicy = {
  id?: string;
  name: string;
  description?: string;
  ptoPolicyItems: PTOPolicyItem[];
  createdAt?: Date;
  updatedAt?: Date;
  standard: boolean;
};

export type PTOPolicyItem = {
  id?: string;
  type: PTOType;
  name: string;
  availableAfterDays: number;
  paidHours: number;
  unpaidHours: number;
  unlimited: boolean;
  minimumHoursPerRequest: number;
  maximumHoursPerRequest?: number;
  hoursCarriedOverToNextYear: number;
  applicableOnWorkingDays: boolean;
  createdAt?: Date;
  updatedAt?: Date;
};

export type PTOTypeBalance = {
  availableHours: number;
  createdAt: string;
  id: string;
  scheduledHours: number;
  staffMemberId: string;
  type: PTOType;
  unlimited: boolean;
  updatedAt: string;
  usedHours: number;
};
